// Base64 Encoder
export const base64Encode = (str) => {
  return btoa(encodeURIComponent(str));
};

// Base64 Decoder
export const base64Decode = (encodedStr) => {
  try {
    const decodedString = decodeURIComponent(atob(encodedStr));
    return decodedString;
  } catch (error) {
    return false; // Handle error gracefully
  }
};
